<div class="flex flex-col md:text-left">
  <form class="hidden sm:block">
    <!-- ORDER BY  -->
    <!-- <div class="border-b border-gray-200 py-4" >
      <div class="flex flex-row gap-3 items-center ">
         <span class="font-medium text-gray-900"> Ordenar por </span>
         <select id="order_options" (change)="change($event)" 
         class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
           block  ">
           <option *ngFor="let option of order_options; let i = index" [value]="i"> {{option.name}}</option>
         </select>
      </div>
     </div> -->
        <!-- BUSCAR POR TEXTO-->
        <!-- <div class="border-b border-gray-200 py-4" >
          <h3 class="capitalize font-medium">Buscar</h3>
          <div class="flex flex-row items-center gap-2 my-3">
            <input class="input-text w-full p-2 text-sm border border-gray-300 text-gray-900 rounded-lg"
             type="text" placeholder="Buscar" (change)="searchText= $event.target.value"/>
          </div>
       </div> -->
     <!-- RANGO DE PRECIO -->
     <!-- <div class="border-b border-gray-200 py-4" >
        <h3 class="capitalize font-medium">Precio</h3>
        <div class="flex flex-row items-center gap-2 my-3">
          <input class="input-text w-24 p-2 text-sm border border-gray-300 text-gray-900 rounded-lg" type="number" min="0" step="1"  placeholder="Minimo" (change)="setMinMaxInput('min',$event)"/>
          <span> - </span>
          <input class="input-text w-24 p-2 text-sm border border-gray-300 text-gray-900 rounded-lg" type="number"  step="1" [min]="filterPrice.min" placeholder="Maximo" (change)="setMinMaxInput('max',$event)"/>
        </div>
     </div> -->
  
      <div class="border-b border-gray-200 py-3" *ngIf="categories.length > 0 ">
        <!-- Expand/collapse section button -->
        <button type="button" (click)="showCategory = !showCategory" class="group flex w-full items-center justify-between bg-white text-gray-400 hover:text-principal focus:text-principal focus:outline-none" aria-controls="filter-section-1" aria-expanded="false">
          <span class="text-xs uppercase text-info">Categories</span>
          <span class="ml-6 flex items-center rounded-full border border-transparent group-focus:border-current">
            <svg *ngIf="showCategory == false" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z" />
            </svg>
            <svg *ngIf="showCategory" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M4 10a.75.75 0 01.75-.75h10.5a.75.75 0 010 1.5H4.75A.75.75 0 014 10z" clip-rule="evenodd" />
            </svg>
          </span>
        </button>
        <!-- Filter section, show/hide based on section state. -->
        <div class="" id="filter-section-1" *ngIf="showCategory">
          <div class="flex flex-col gap-2" [ngClass]="category.open && category.sub_categories.length > 0 ? 'mb-4' : ''" *ngFor="let category of categories">
            <button type="button"  class="group flex w-full items-center justify-between bg-white py-2 text-sm text-gray-400 hover:text-principal focus:text-principal focus:outline-none">
              <span class="text-xs uppercase text-info" *ngIf="category.sub_categories.length > 0">{{isCollection(category.name) ? 'Collections' : category.name}}</span>
              <ng-container *ngIf="category.sub_categories.length == 0">
                      <label [for]="category.id" class="text-xs uppercase text-info">{{category.name}}</label>
                      <input [id]="category.id" [name]="category.id" [value]="category.id" [checked]="currentCategory.id == category.id" (change)="addCategory($event,category)" type="checkbox" class="mr-1 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500">
                </ng-container>
                <span (click)="category.open = !category.open" class="ml-6 flex items-center rounded-full border border-transparent group-focus:border-current" *ngIf="category.sub_categories.length > 0">
                  <!-- Expand icon, show/hide based on section open state. -->
                  <svg  *ngIf="category.open == false" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z" />
                  </svg>
                  <!-- Collapse icon, show/hide based on section open state. -->
                  <svg *ngIf="category.open" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M4 10a.75.75 0 01.75-.75h10.5a.75.75 0 010 1.5H4.75A.75.75 0 014 10z" clip-rule="evenodd" />
                  </svg>
              </span>
            </button>
            <ng-container *ngIf="category.open">
              <div class="flex items-center ml-6" *ngFor="let ctg of category.sub_categories">
                  <input [id]="ctg.id" [name]="ctg.id" [value]="ctg.id" [checked]="currentCategory.id == ctg.id || currentSubCategory?.id == ctg.id" (change)="addCategory($event,ctg)" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500">
                  <label [for]="ctg.id" class="ml-3 flex-1 text-xs text-gray-600 hover:text-principal cursor-pointer">{{ctg.name}}</label>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
        <!-- FILTROS -->
        <div class="border-b border-gray-200 py-4" *ngFor="let filter of filtersList">
        <!-- Expand/collapse section button -->
        <button type="button" (click)="filter.open = !filter.open"  class="group flex w-full items-center justify-between bg-white text-sm text-gray-400 hover:text-principal focus:text-principal focus:outline-none" aria-controls="filter-section-1" aria-expanded="false">
          <span class="font-medium text-gray-900">{{filter.name}}</span>
          <span class="ml-6 flex items-center rounded-full border border-transparent group-focus:border-current">
            <!-- Expand icon, show/hide based on section open state. -->
            <svg *ngIf="filter.open == false" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z" />
            </svg>
            <!-- Collapse icon, show/hide based on section open state. -->
            <svg *ngIf="filter.open" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M4 10a.75.75 0 01.75-.75h10.5a.75.75 0 010 1.5H4.75A.75.75 0 014 10z" clip-rule="evenodd" />
            </svg>
          </span>
        </button>
        <!-- Filter section, show/hide based on section state. -->
        <div class="pt-3 flex flex-col gap-2" id="filter-section-1" *ngIf="filter.open">
          <div class="flex items-center ml-2" *ngFor="let option of filter.options">
            <input [id]="option.id_number" [name]="option.id_number" [value]="option.value" (change)="addFilter($event,filter,option)" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500">
            <label [for]="option.id_number" class="ml-3 flex-1 text-sm text-gray-600 capitalize hover:text-principal cursor-pointer">{{option.value}}</label>
          </div>
        </div>
      </div>
      <div class="py-4">
        <button type="button" (click)="applyFilters()" class="w-full bg-principal-claro text-principal text-sm px-6 py-2 transform hover:scale-110 hover:z-10 transition-transform ease-in-out duration-500 focus:outline-none whitespace-nowrap" >
            Aplicar Filtros
        </button>
      </div>
    </form>
</div>